export const CMS_SEO_CONFIG = {
  pageTitle: {
    maxLength: 80,
  },
  internalTitle: {
    maxLength: 80,
  },
  slug: {
    maxLength: 120,
  },
  pageDescription: {
    maxLength: 158,
  },
  socialTitle: {
    maxLength: 160,
  },
  socialDescription: {
    maxLength: 160,
  },
  pageKeywords: {
    maxLength: 40,
  },
  thumbnail: {
    size: {
      width: 800,
      height: 600,
    },
  },
  thumbnailBig: {
    size: {
      width: 1200,
      height: 1200,
    },
  },
};

export const initEmptySeoTemplate = {
  title: "",
  description: "",
  pageKeywords: "",
  slug: "",
  thumbnail: "",
  thumbnailBig: "",
  socialTitle: "",
  socialDescription: "",
  // articleModifiedTime: "",
  // articlePublishedTime: "",
};